import { CardWithLable, PDFPreview, Spinner, Table } from "@public/ui-toolkit";
import ReactDropDown from "@public/ui-toolkit/src/ReactSelect";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import UplaodPerformanceMetrixModal from "../UploadPerformanceMetrixModal";
import {
  CanCan,
  Permissions,
} from "@hedgefund/shared";
import { debounce } from "lodash";
import { alertService } from "../Alert";
import { Row, Col } from "antd";



const FundTearSheet = ({ fund, onCreateAuditLogs, monthlyReturnPerformance, loading, portal = "Allocator", tableLoading,
  handleYearChange, getPerformanceMetricsSearchResult, uploadTearSheet, tearSheetLoading = false, updateMonthlyReturn,
  fundId, performanceMetrcisMonth }) => {
  const [selectedPMMonthValue, setSelectedPMMonthValue] = useState("");
  const [performanceMetrcisYear, setPerformanceMetrcisYear] = useState(null);
  const [performanceMetricsDocument, setPerformanceMetricsDocument] = useState(null);
  const [selectedOption, setSelectedOption] = useState(0);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      marginRight: "10px",
    }),
  };

  const columns = [
    { name: "Year", key: "year" },
    { name: "January", key: "january" },
    { name: "Febuary", key: "february" },
    { name: "March", key: "march" },
    { name: "April", key: "april" },
    { name: "May", key: "may" },
    { name: "June", key: "june" },
    { name: "July", key: "july" },
    { name: "August", key: "august" },
    { name: "September", key: "september" },
    { name: "October", key: "october" },
    { name: "November", key: "november" },
    { name: "December", key: "december" },
    { name: "Ytd", key: "ytd", toFixed: 2 },

  ];

  const dispatch = useDispatch();
  useEffect(() => {
    if (fundId) {
      getSelectedYearValue();
      var initializationDate = new Date(fund.initializationDate);
      var today = new Date();
      var initializationYear = initializationDate.getFullYear();
      var currentYear = today.getFullYear();
      var diffDate = currentYear - initializationYear;
      const ListOfYears = [];
      for (let index = 0; index <= diffDate; index++) {
        const date = initializationYear + index;
        ListOfYears.push({ value: date, label: date });
      }
      setPerformanceMetrcisYear(ListOfYears);
    }
  }, [fundId])

  const getSelectedYearValue = () => {
    const currentMonth = new Date(fund?.performanceMetrics?.month);
    const month = currentMonth.toLocaleString('default', { month: 'long' });
    const year = { value: currentMonth.getFullYear(), label: currentMonth.getFullYear() };
    setSelectedOption(year.value > 0 ? year : "");
    setSelectedPMMonthValue(year.value > 0 ? { value: month, label: month } : "");
    if (year.value > 0) {
      dispatch(getPerformanceMetricsSearchResult({ id: fundId, year: year.value }));
    }
  }

  // Filter latest 5 rows in table
  const filterFirstFiveRow = (values) => {
    let filteredLatest5YearRows = values;
    let monthlyReturn = filteredLatest5YearRows?.slice(0, 5);
    return monthlyReturn;
  };

  const handleChangeMonthlyReturn = debounce((e, columnIndex, rowIndex) => {
    if (e.key === "Enter") {
      const currentYear = moment().format("yyyy") - rowIndex;
      const currentMonth = `${currentYear}-${columnIndex}-01`;
      const splitMonthlyReturn = e.target.innerHTML.split("br");
      const secondSplit = splitMonthlyReturn[0].split("<");
      const monthlyReturn = secondSplit[0];

      dispatch(
        updateMonthlyReturn({
          fundId: fundId,
          monthlyReturn: monthlyReturn,
          month: currentMonth,
        })
      );
    }
  }, 3000);

  const onSuccess = () => {
    alertService.success("Successfully uploaded!", { autoClose: true });
  };

  const handleYearsChange = (e) => {
    let presentYear = e.value;
    setSelectedOption({ value: presentYear, label: presentYear });
    handleYearChange(presentYear);
  }

  return (
    <Row className="component mt-3" >
      <Col span={24} className="component-header">
        <Row style={{ padding: "10px" }}>
          <Col span={14} style={{margin:"auto"}} >
            <div className="Fund-FontSize" style={{ fontSize : "26px" }}>Performance Snapshot</div>
          </Col>
          <Col span={10} >
            <Row style={{ justifyContent: "end" }}>
              <CanCan permissionName={Permissions?.TEAR_SHEET_UPLOAD?.name}>
                <UplaodPerformanceMetrixModal
                  uploadTearSheet={uploadTearSheet}
                  onSuccess={onSuccess}
                  id={fundId}
                  loading={tearSheetLoading}
                />
              </CanCan>
              <a
                href="/"
                className="hf-btn hf-btn-white"
                target="_blank"
                download
                disabled={!fund?.performanceMetrics}
                onClick={() => {
                  if (portal === "Allocator") {
                    const values = {
                      actionName: "Download Latest Tear Sheet",
                      parameters: { month: moment(fund?.performanceMetrics?.month).format("MM-YYYY") }
                    }
                    onCreateAuditLogs(values);
                  }
                  window.open(fund?.performanceMetrics?.documentUrl)
                }
                }
              >
                <i
                  className="fa fa-download mr-2"
                  aria-hidden="true"
                ></i>
                {!fund?.performanceMetrics
                  ? "No Tear Sheet Available"
                  : "Download Latest Tear Sheet"}
              </a>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col span={24} className="component-body">
        <CardWithLable title={`${fund?.name} Performance Snapshot`}>
          <div className="hf-card2-body px-0 pb-0">
            <div className="hf-table">
              {(() => {
                if (portal === "Allocator") {
                  return (
                    <Table
                      columns={columns}
                      NoFound={"No Snapshot Found"}
                      data={filterFirstFiveRow(monthlyReturnPerformance)}
                    />
                  )
                } else {
                  if (tableLoading) {
                    return (<Spinner />)
                  } else {
                    return (
                      <Table
                        columns={columns}
                        NoFound={"No Snapshot Found"}
                        data={filterFirstFiveRow(monthlyReturnPerformance)}
                        contentEditable={true}
                        onKeyPress={(e, columnIndex, rowIndex) =>
                          handleChangeMonthlyReturn(
                            e,
                            columnIndex,
                            rowIndex
                          )
                        }
                      />
                    )
                  }
                }
              })()}
            </div>
          </div>
        </CardWithLable>
      </Col>

      <Col span={24} className="mt-4">        
        <Row style={{ padding: "10px" }}>
          <Col span={16}>
            <div className="Fund-FontSize" style={{ fontSize : "26px" }}>{`${fund?.name} Performance Metrics`}</div>
          </Col>
          <Col span={8} >
            <Row style={{ justifyContent: "end" }}>
              <ReactDropDown
                styles={customStyles}
                isDisabled={selectedOption ? false : true}
                selectedValue={selectedOption ? selectedOption : { value: "Year", label: "Year" }}
                onChange={handleYearsChange}
                performanceMetrcisResult={performanceMetrcisYear}
              />
              <ReactDropDown
                
                isDisabled={selectedOption ? false : true}
                selectedValue={selectedPMMonthValue ? selectedPMMonthValue : { value: "Month", label: "Month" }}
                pmLoading={loading}
                onChange={
                  (monthObj) => {
                    var selected = performanceMetrcisMonth?.filter(
                      (u) => moment(u.month).format("MMMM") === monthObj.value
                    );
                    if (selected?.length) {
                      setSelectedPMMonthValue(monthObj);
                      setPerformanceMetricsDocument(selected[0].documentUrl);
                      if (portal === "Allocator") {
                        
                        const value = {
                          actionName: "View Tear Sheet",
                          parameters: { id: fundId, month: monthObj.value, year: selectedOption.value }
                        }
                        onCreateAuditLogs(value);
                      }
                    }
                  }}
                performanceMetrcisResult={performanceMetrcisMonth?.map((it) => {
                  return ({ value: moment(it.month).format("MMMM"), label: moment(it.month).format("MMMM") })
                })}
              />
            </Row>
          </Col>
        </Row>
      </Col>
      {performanceMetricsDocument !== null || fund.performanceMetrics !== null ? (
        <Col span={24} style={{ backgroundColor: "#fff" }}>
          <PDFPreview
            src={
              performanceMetricsDocument ||
              fund?.performanceMetrics?.documentUrl
            }
            title="pdf-preview"
          />
        </Col>
      ) : (
        <Col span={24}
          className="alert alert-primary text-center w-75 d-flex m-auto justify-content-center mt-5"
          role="alert"
        >
          No Performance Document Found {selectedOption == 0 ? "" : selectedOption}
        </Col>
      )}
    </Row>
  )
};

export default FundTearSheet;
